import React, { useState } from "react";

// Lazy YouTube embed ("facade" pattern): renders the thumbnail until the visitor clicks, then
// swaps in the real iframe. A plain <iframe> pulls in roughly a megabyte of YouTube script on
// page load, which would hurt Core Web Vitals on the landing page - this keeps the initial cost
// to one image. youtube-nocookie.com means no tracking cookies are set unless the video is
// actually played.
export default function VideoEmbed({ videoId, title, className = "" }) {
  const [playing, setPlaying] = useState(false);

  return (
    <div
      className={
        "relative overflow-hidden rounded-2xl border border-slate-200 dark:border-gray-700 bg-slate-900 shadow-sm " +
        className
      }
    >
      <div className="aspect-video w-full">
        {playing ? (
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
            title={title}
            className="h-full w-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        ) : (
          <button
            type="button"
            onClick={() => setPlaying(true)}
            aria-label={`Play video: ${title}`}
            className="group relative h-full w-full"
          >
            <img
              src={`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`}
              alt=""
              loading="lazy"
              className="h-full w-full object-cover"
            />
            <span className="absolute inset-0 flex items-center justify-center bg-black/25 transition group-hover:bg-black/35">
              <span className="flex h-16 w-16 items-center justify-center rounded-full bg-red-600 shadow-lg transition group-hover:scale-105">
                <svg viewBox="0 0 24 24" className="ml-1 h-7 w-7 text-white" fill="currentColor" aria-hidden="true">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </span>
            </span>
          </button>
        )}
      </div>
    </div>
  );
}
